/**
 * @constant 海报类型
 * @description 海报类型
 * @author hutao
 */
export const POSTER_TYPE = {
  makerPoster: 1, // 自制海报
  activityPoster: 2, // 活动海报
  specialPoster: 3 // 特价海报
}

/**
 * @constant 活动状态
 * @description 特价活动状态
 * @author guoxt
 */
export const ACTIVITY_STATE = {
  pending: 1, // 进行中
  notStart: 2, // 未开始
  finished: 3 // 已完成
}

/**
 * @constant 支付方式
 * @description 支付方式
 * @author guoxt
 */
export const PAY_TYPE = {
  wechat: 1, // 微信支付
  alipay: 2, // 支付宝支付
  vip: 3 // 会员支付
}

/**
 * @constant 订单类型
 * @description 订单类型
 * @author guoxt
 */
export const ORDER_MODE = {
  immediately: 1, // 立即取单
  appointment: 2 // 预约取单
}

/**
 * @constant 订单类型
 * @description 订单类型
 * @author guoxt
 */
export const DISTRIBUTION_MODE = {
  pickup: 1, // 自提
  takeout: 2 // 外卖
}

// 订单类型
export const ORDER_TYPE = {
  all: 3, // 所有订单
  todo: 5, // 待处理订单
  abnormal: 7, // 异常
  finished: 6 // 已完成
}
// 订单状态
export const ORDER_STATUS = {
  normal: 1, // 正常订单
  unusual: 2 // 异常订单
}
export const TAKE_ORDER_FLAG = {
  alreadyTake: 1, // 已取单
  notTake: 2 // 未取单
}
/**
 * @constant 是否是活动订单
 * @author guoxt
 */
export const ACTIVITY_FLAG = {
  notActivity: 1,
  isActivity: 2
}

/**
 * @constant 参与用户类型
 * @description 参与用户类型
 * @author guoxt
 */
export const ACTIVITY_USER_TYPE = {
  all: 1, // 所有用户
  member: 2, // 会员用户
  notMember: 3 // 非会员用户
}

/**
 * @constant 参与用户类型
 * @description 参与用户类型
 * @author guoxt
 */
export const MINA_SHARE_TYPE = {
  other: 1, // 1-付呗生活(点单业务)
  receipt: 2 // 2-收款单业务,不传时默认为付呗生活
}

/**
 * @constant 分享类型
 * @description 分享类型
 * @author hutao
 */
export const SHARE_TYPE = {
  poster: 1, // 自制海报
  mina: 2, // 活动海报
  string: 3 // 特价海报
}

/**
 * @constant 分享平台
 * @description 分享平台（支付宝，微信）1:微信朋友 2:微信朋友圈 3:支付宝朋友
 * @author hutao
 */
export const SHARE_PLATFORM = {
  wechat_friend: 1, // 自制海报
  wechat_friend_circle: 2, // 活动海报
  alipay_friend: 3 // 特价海报
}

/**
 * @constant 分享类型
 * @description 分享类型(1:文本 2:图片 3: 小程序 4：超链接)
 * @author hutao
 */
export const SHARE_FRIEND_TYPE = {
  string: 1, // 文字
  image: 2, // 图片
  mina: 3, // 小程序
  link: 4 // 超链接
}
/**
 * @constant 小助教和收款单分享类型
 * @description 分享类型（1:分享微信小程序 2:发送微信海报 3:保存海报 4:保存二维码 5:发送支付宝海报）
 */
export const SHARE_PLATFORM_TEACH = {
  mina: 1, // 分享小程序
  sendPoster: 2, // 发送海报 微信
  sendPosterAli: 5, // 发送海报 支付宝
  savePoster: 3, // 保存海报
  saveQRcode: 4 // 保存二维码
}
/**
 * @constant 角色类型
 * @description 角色类型
 * @author guoxt
 */
export const ROLE_TYPE = {
  boss: 0, // 总账号
  shopOwner: 1, // 店长
  checker: 2, // 收银员
  waiter: 3 // 服务员
}

/**
 * @constant 特价海报状态
 * @description 特价海报状态
 * @author guoxt
 */
export const SP_POSTER_STATUS = {
  pending: 1, // 进行中
  nostart: 2, // 未开始
  ending: 3 // 已结束
}
/**
 * @constant 订单列表展示状态
 * @type {{'1': string, '2': string, '3': string, '4': string, '5': string}}
 */
export const ORDER_LIST_TYPE = {
  orderSuc: 1, // 顾客已下单
  driverOrder: 2, // 骑手已接单
  driverArrive: 3, // 骑手到店
  driverTakeGood: 4, // 骑手已取货
  driverFinish: 5 // 已完成
}
/**
 * 确认呼叫骑手状态
 * @type {{isSucCall: number, isFailCall: number}}
 */
export const CALL_DRIVER_STATUS = {
  isSucCall: 1,
  isFailCall: 2
}
/**
 * 确认呼叫骑手失败
 * @type {{merchantShotBalance: number, fubeiShorBalance: number}}
 */
export const CALL_DRIVER_FAIL_REASON = {
  merchantShotBalance: 1,
  fubeiShotBalance: 2
}
/**
 * 呼叫骑手cell展示信息
 * @type {{weight: number, service: number}}
 */
export const CALL_DRIVER_SHEET_TYPE = {
  weight: 1,
  service: 2
}
/**
 * 订单状态
 * @type {{oderSuc: number, riderOrderSuc: number, riderToShop: number, riderTakeGood: number, orderFinish: number}}
 */
export const ORDER_LIST_DELIVERY_STATUS = {
  canOperateType: 0, // 关闭第三方配送
  callDriver: 1, // 呼叫骑手
  cancelCall: 2, // 取消呼叫
  reCallDriver: 3 // 重新呼叫
}
/**
 * 是否支持三方配送
 * @type {{support: number, noSupport: number}}
 */
export const ORDER_LIST_SUPPOT_DELIVERY = {
  support: 1, // 支持三方配送
  noSupport: 2 // 不支持三方配送
}
/**
 * 订单详情联系人类型
 * @type {{customer: number, driver: number}}
 */
export const ORDER_DETAIL_CONCAT = {
  customer: 1,
  driver: 2
}
/**
 * 是否可以呼叫骑手
 * @type {{canCall: number, cantCall: number}}
 */
export const ORDER_LIST_IS_CAN_CALL = {
  canCall: 1, // 可以呼叫
  cantCall: 2 // 不可以呼叫
}
/**
 * 呼叫失败原因
 * @type {{merchantLack: number, fubeiLack: number}}
 */
export const ORDER_LIST_CALL_FAIL = {
  merchantLack: 1, // 商户余额不足
  fubeiLack: 2 // 呼叫异常，联系客服
}
/**
 * 取消呼叫原因cell的index默认值
 * @type {{currentIndex: number, selectIndex: number}}
 */
export const CANCEL_REASON_SELECT = {
  currentIndex: 0, // cell当前默认index
  selectIndex: -1 // cell选中的index默认值
}
/**
 * 呼叫骑手信息是否可以修改
 * @type {{canModify: number, cantModify: number}}
 */
export const CALL_DRIVER_MODIFY = {
  canModify: 1, // 能修改
  cantModify: 2 // 不能修改
}
/**
 * 充值支付方式
 * @type {{alipay: number}}
 */
export const PAY_WAY_LIST = {
  alipay: 1 // 支付宝
}
/**
 * 三方配送是否签署协议
 * @type {{need: number, cantNedd: number}}
 */
export const THIRD_DELIVERY_NEES_SIGN = {
  noStatus: -1, // 无状态
  need: 1, // 需要签署
  cantNedd: 2 // 不需要签署
}
/**
 * 三方配送，门店状态
 * @type {{noOpen: number, review: number, opened: number, rejected: number}}
 */
export const THIRD_DELIVERY_STOR_STATUS = {
  noOpen: 1, // 未审核
  review: 2, // 审核中
  opened: 3, // 已开通
  rejected: 4 // 审核驳回
}
/**
 * 签署三方配送协议状态或者提交资料是否成功
 * @type {{suc: number, faile: number}}
 */
export const THIRD_DELIVERY_SIGN_RESULT = {
  suc: 1, // 签署成功
  faile: 2 // 失败
}
/**
 * 填写资料页面从哪个页面跳转来的
 * @type {{multiplatformDelivery: number, agreement: number}}
 */
export const THIRD_DELIVERY_SIGN_PAGE_FROM = {
  multiplatformDelivery: 1, // 三方配送主页
  agreement: 2 // 协议页面
}
/**
 * 订单页面tips颜色
 * @type {{red: number, orange: number}}
 */
export const ORDER_ALERT_COLOR = {
  red: 1, // 红色
  orange: 2 // 橙色
}
/**
 * 订单列表
 * @type {{canHandle: number, cantHandle: number}}
 */
export const ORDER_LIST_DEALBUTTON_STATUS = {
  canHandle: 1, // 显示处理订单按钮
  cantHandle: 2 // 不显示处理订单按钮
}
/**
 * 选择相片来源
 * @type {{camera: number, photo: number}}
 */
export const SELECT_IMG_FROM_TYPE = {
  camera: 0, // 相机
  photo: 1 // 相册
}
/**
 * app来源
 * @type {{pos: number, android: number, ios: number}}
 */
export const APP_SOURCE_TYPE = {
  pos: 1, // 来源pos
  android: 0, // 安卓
  ios: 2 // ios
}
/**
 * app版本号
 * @type {{ios: number, android: number}}
 */
export const APP_VERSION = {
  ios: 376, // ios版本
  android: 4018 // 安卓版本
}
export const SEPERATE_TIME_APP_VERSION = {
  ios: 424,
  android: 4224
}
/**
 * 收款单app版本号
 */
export const RECECEIPT_APP_VERSION = {
  ios: 411,
  android: 4206
}
/**
 * 三方配送-开通门店图片选择
 * @type {{cant: number, can: number}}
 */
export const IMG_EDITE = {
  cant: 0, // 预览
  can: 1 // 操作
}
/**
 * 协议校验
 * @type {{tipCheck: number, noTipCheck: number}}
 */
export const DELIVERY_PROTOCOL_CHECK = {
  tipCheck: 1, // 需要校验
  noTipCheck: 2 // 不需要校验
}
/**
 * 是否显示联系骑手按钮
 * @type {{call: number, cantCall: number}}
 */
export const ORDER_LIST_CONCAT_DRIVER = {
  call: 1, // 显示联系骑手
  cantCall: 2 // 不显示
}
/**
 * 余额详情类型
 * @type {{recharge: number}}
 *  1: '充值',
      2: '支出',
      3: '退款',
      4: '支出',
 * 1-充值;2-扣减配送费;3-退还配送费;4-取消配送扣减手续费，5-订单取消退款,6-订单有责取消扣款,7-退还配送费失败
 */
export const BALANCE_DETAIL_SOURCE_FROM = {
  recharge: 1, // 充值
  deliveryFees: 2, // 扣减配送费
  refund: 3, // 退还配送费
  handlingFee: 4, // 扣减手续费
  refundFail: 7 // 退款失败
}
/**
 * 订单详情是否支持三方配送
 * @type {{support: number, cantSupport: number}}
 */
export const ORDER_DETAIL_SUPPORT_THIRDDELIVERY = {
  support: 1, // 支持三方配送
  cantSupport: 2 // 不支持三方配送
}
/**
 * 友店权限：1-有权限；2-无权限
 */
export const ASSISTANT_GRANT = {
  opened: 1,
  unopen: 2
}

/**
 * @constant 预授权支付渠道
 * @author hutao
 */
export const DEPOSIT_CHANNEL = {
  POS: 12, // POS机
  MOBILE: 7 // 手机APP
}

/**
 * 特价活动-重新发布跳转页面
 */
export const RE_DISPATCH_PAGE = {
  1: 'newAddGoods', // 特价活动-新的添加商品页面
  2: 'addSpecialGoods' // 特价活动-老的添加商品页面
}

/**
 * 特价活动-重新发布跳转页面
 */
export const GROUP_ACTIVITY_STATE = {
  pending: 1,
  notStart: 2,
  finished: 3
}

/**
 * @constant 特价活动-创建过程中的类型
 */
export const ACTIVITY_CREATE_MODE = {
  choose: 'choose', // 商品库添加商品
  newAdd: 'newAdd', // 手动添加商品
  edit: 'edit', // 编辑
  reDispatch: 'reDispatch' // 重新发布
}
/**
 * @constant 特价活动详情-操作
 */
export const ACTIVITY_DETAIL_ACTION = {
  edit: 'edit',
  close: 'close'
}
/**
 * @constant 特价活动详情-操作MAP
 */
export const ACTIVITY_DETAIL_ACTION_MAP = {
  [ACTIVITY_DETAIL_ACTION.edit]: '编辑',
  [ACTIVITY_DETAIL_ACTION.close]: '关闭活动'
}

export const WEEK_LIST = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']

// 教培行业状态值
export const TEACH_TRAIN_STATUS = {
  all: -1, // 全部
  notStart: 1, // 未收款
  pending: 2, // 收款中
  close: 3, // 已关闭
  timeout: 4, // 超时
  success: 5 // 收款完成
}
export const TEACH_TRAIN_STATUS_COLORS = {
  [TEACH_TRAIN_STATUS.notStart]: {
    text: '未收款',
    color: '#4699F9',
    bgColor: '#EBF4FF'
  },
  [TEACH_TRAIN_STATUS.pending]: {
    text: '收款中',
    color: '#E6B217',
    bgColor: '#FFFAEB'
  },
  [TEACH_TRAIN_STATUS.close]: {
    text: '已关闭',
    color: '#818999',
    bgColor: '#F2F3F5'
  },
  [TEACH_TRAIN_STATUS.timeout]: {
    text: '已超时',
    color: '#F04144',
    bgColor: '#FFF5F5'
  },
  [TEACH_TRAIN_STATUS.success]: {
    text: '已完成',
    color: '#1BB373',
    bgColor: '#EBFFF6'
  }
}
// 收款单类型 商家输入 用户输入 顾客导出 由收款项决定
export const COLLECT_TYPE = {
  MERCHANT_INPUT: 1,
  USER_INPUT: 2,
  MERCHANT_EXPORT: 3,
  PROJECT: 4
}
// 商品规格  多规格商品 单规格商品
export const SKU_TYPE = {
  multiple: 1,
  single: 2
}

// 配送方式状态
export const DELIVERY_PICK = {
  canSelfPick: 1, // 可自提
  canOutDelivery: 1 // 可外送
}
/**
 * 配送方式
*/
export const DELIVERY_TYPE = {
  null: '',
  deliveryAndPick: '自提+外送',
  delivery: '外送',
  pick: '自提'
}
/**
 * 是否开通第三方配送
*/
export const IS_THIRD_DELIVERY = {
  yes: 1, // 是
  no: 2 // 否
}
/**
 * 是否显示开通三方配送弹窗
*/
export const IS_DISPLAY_TYPE = {
  yes: 1, // 是
  no: 2 // 否
}
/**
* 下拉到底基础像素
*/
export const BASE_PX = 50
/**
 * @constant 支付方式
 */
export const PAYTYPE_TEXT = {
  WECHAT: 1, // 微信
  ALIPAY: 2, // 支付宝
  MEMBER: 3 // 会员支付
}
/**
* @constant  导出成功
*/
export const EXPORT_STATUS = {
  SUCCESS: 1

}
/**
 * @constant 订单详情账单入口版本
 */
export const APP_VERSION_BILL = {
  android: '4.3.04',
  ios: '4.3.4'
}
/**
 * @constant 日志地址
 */
export const LOGGER_HOST = 'cn-hangzhou.log.aliyuncs.com'
/**
 * @constant Project名称
 */
export const TRACKER_PROJECT = 'fshows-ecs-pro'
/**
 * @constant Logstore名称
 */
export const TRACKER_LOGSTORE = 'web-fubei-app-log'
/**
 * 微信支付后发券
*/
export const WX_AFTER_PAYMENT = {
  open: 1, // 开启
  close: 2 // 关闭
}
/**
 * 商家小程序内发券
*/
export const MINA_PROGRAM_PAYMENT = {
  open: 1, // 开启
  close: 2 // 关闭
}
// 顾客信息类型状态
export const RECEIPT_FORM_TYPE = {
  TEXT: 1,
  PHONE: 2,
  RADIO: 3,
  CHECKBOX: 4,
  PICTURE: 5
}

/**
 * @constant 一些固定日期常量map字符串
 * @details 可列举例如昨天，前天... 时间戳
 */
export const FIX_DATE_MAP = {
  // 自然日
  NATURAL_DAY: '00:00:00 ~ 23:59:59',
  // 当天开始
  NATURAL_DAY_START: '00:00:00',
  // 当天结束
  NATURAL_DAY_END: '23:59:59'
}

/**
 * @constant 字符位数超出条件
 */
export const OVERFLOW_HIDDEN_TYPE = {
  EIGHT: '8', // 超出8个字符的隐藏条件
  NINE: '9', // 超出9个字符的隐藏条件
  TEN: '10', // 超出10个字符的隐藏条件
  TWENTY: '20', // 超出20个字符的隐藏条件
  SPECIAL_36: '36', // 超出36个字符的隐藏条件特殊条件下
  SPECIAL_32: '32' // 超出36个字符的隐藏条件特殊条件下
}

/**
 * @constant 字符位数超出条件对应的字段名
 */
export const OVERFLOW_HIDDEN_NAME = {
  COUNT: 'count', // 字符长度
  START: 'start', // 开始截取字符
  END: 'end', // 结束截取字符
  STR_LENGTH: 'strLength' // 传入指定的字符长度
}

/**
 * @constant 字符位数超出条件对应的字段值
 */
export const OVERFLOW_HIDDEN_MAP = {
  [OVERFLOW_HIDDEN_TYPE.NINE]: {
    [OVERFLOW_HIDDEN_NAME.COUNT]: 9,
    [OVERFLOW_HIDDEN_NAME.START]: 4,
    [OVERFLOW_HIDDEN_NAME.END]: -4
  },
  [OVERFLOW_HIDDEN_TYPE.TEN]: {
    [OVERFLOW_HIDDEN_NAME.COUNT]: 10,
    [OVERFLOW_HIDDEN_NAME.START]: 5,
    [OVERFLOW_HIDDEN_NAME.END]: -4
  },
  [OVERFLOW_HIDDEN_TYPE.TWENTY]: {
    [OVERFLOW_HIDDEN_NAME.COUNT]: 19,
    [OVERFLOW_HIDDEN_NAME.START]: 9,
    [OVERFLOW_HIDDEN_NAME.END]: -8
  },
  [OVERFLOW_HIDDEN_TYPE.SPECIAL_36]: {
    [OVERFLOW_HIDDEN_NAME.COUNT]: 36,
    [OVERFLOW_HIDDEN_NAME.START]: 17,
    [OVERFLOW_HIDDEN_NAME.END]: 16
  },
  [OVERFLOW_HIDDEN_TYPE.SPECIAL_32]: {
    [OVERFLOW_HIDDEN_NAME.COUNT]: 32,
    [OVERFLOW_HIDDEN_NAME.START]: 15,
    [OVERFLOW_HIDDEN_NAME.END]: 14
  }
}

/**
 * @constant 预览组件桥接版本号
 */
export const PREVIEW_JS_BRIDGE_VERSION = {
  ios: 464,
  android: 4513
}

/**
 * @constant 商品类型 1-普通商品 2-套餐商品
*/
export const GOODS_METHOD = {
  normal: 1, // 普通商品
  package: 2 // 套餐商品
}

export const URL_MAP = {
  success_icon: '@/assets/images/success_icon.png'
}

/**
 * @constant 步骤状态
 */
export const STEP_STATUS = {
  success: 'success', // 成功
  error: 'error', // 失败
  edit: 'editing', // 编辑
  default: 'default', // 默认
  drafts: 'drafts' // 草稿
}

/**
 * @constant 步骤值
 */
export const STEP_STATUS_VALUE = {
  goodInfo: 1, // 商品信息
  sellInfo: 2, // 售卖信息
  invoiceInfo: 3 // 发票信息
}
/**
 * @function 本地图片枚举
 */
export const IMG_URL_ENUM = {
  backBlackIcon: require('@/assets/images/common/icon_back_black_arrow.png'),
  wechatIcon: require('@/assets/images/invoice/invoice_wechat_icon.png'),
  alipayIcon: require('@/assets/images/invoice/invoice_ali_icon.png'),
  clearIcon: require('@/assets/images/close_icon_grey.png'),
  searchIcon: require('@/assets/images/assistant/icon_search.png'),
  invoiceEmptyIcon: require('@/assets/images/electronicInvoice/list_empty.png'),
  invoiceSearchEmptyIcon: require('@/assets/images/electronicInvoice/search_empty.png'),
  back: require('@/assets/images/help/custom_back_icon.png'),
  redAddGray: require('@/assets/images/digitalMarketing/client_icon_add.png'),
  arrowRight: require('@/assets/images/teachTrain/arrow_right.png'),
  emptyIcon: require('@/assets/images/assistant/student_empty_icon.png'),
  photoIcon: require('@/assets/images/hardwareRefund/icon_takephoto.png'),
  addIcon: require('@/assets/images/receiptManager/add_icon.png'),
  bookIcon: require('@/assets/images/receiptManager/book_icon.png'),
  pictureIcon: require('@/assets/images/receiptManager/picture_icon.png'),
  dragIcon: require('@/assets/images/receiptManager/drag_icon.png'),
  clear2Icon: require('@/assets/images/receiptManager/clear2_icon.png'),
  closeIcon: require('@/assets/images/receiptManager/close_icon.png'),
  storeIcon: require('@/assets/images/receiptManager/store_icon.png'),
  selectIcon: require('@/assets/images/receiptManager/select_icon.png'),
  eyeIcon: require('@/assets/images/receiptManager/eyes_icon.png'),
  addNumDisabledIcon: require('@/assets/images/receiptManager/add_num_disabled_icon.png'),
  addNumIcon: require('@/assets/images/receiptManager/add_num_icon.png'),
  subNumDisabledIcon: require('@/assets/images/receiptManager/sub_num_disabled_icon.png'),
  subNumIcon: require('@/assets/images/receiptManager/sub_num_icon.png'),
  gpsIcon: require('@/assets/images/receiptManager/gps_icon.png'),
  radioTypeIcon: require('@/assets/images/receiptManager/radio_type_icon.png'),
  checkboxTypeIcon: require('@/assets/images/receiptManager/checkbox_type_icon.png'),
  mulitTextIcon: require('@/assets/images/receiptManager/mulit_text_icon.png'),
  singleTextIcon: require('@/assets/images/receiptManager/single_text_icon.png'),
  aiNavIcon: require('@/assets/images/receiptManager/ai_nav_icon.png'),
  aiMsgIcon: require('@/assets/images/receiptManager/ai_msg_icon.png'),
  aiVoiceIcon: require('@/assets/images/receiptManager/ai_voice_icon.png'),
  aiKeyboardIcon: require('@/assets/images/receiptManager/ai_keyboard_icon.png'),
  aiSendIcon: require('@/assets/images/receiptManager/ai_send_icon.png'),
  aiChatIcon: require('@/assets/images/receiptManager/ai_chat.png'),
  redSendIcon: require('@/assets/images/receiptManager/red_send_icon.png'),
  closeWhiteIcon: require('@/assets/images/receiptManager/close_white_icon.png'),
  downSelectIcon: require('@/assets/images/receiptManager/down_select_icon.png'),
  aiHelperIcon: require('@/assets/images/receiptManager/receipt_ai_helper.png'),
  aiHelperGuide: require('@/assets/images/receiptManager/receipt_ai_guide.png'),
  imageIcon: require('@/assets/images/receiptManager/image_icon.png'),
  mapIcon: require('@/assets/images/receiptManager/map_icon.png'),
  addressInfoIcon: require('@/assets/images/receiptManager/address_info_icon.png'),
  dateIcon: require('@/assets/images/receiptManager/date_icon.png'),
  tipIcon: require('@/assets/images/receiptManager/tip_icon.png'),
  delIcon: require('@/assets/images/receiptManager/del_icon.png'),
  customerEmptyIcon: require('@/assets/images/receiptManager/customer_empty_icon.png'),
  scan_icon: require('@/assets/images/stateSubsidies/scan_icon.png'),
  poster_bg_1: require('@/assets/images/receiptManager/poster/poster_bg_1.png'),
  poster_bg_2: require('@/assets/images/receiptManager/poster/poster_bg_2.png'),
  poster_bg_3: require('@/assets/images/receiptManager/poster/poster_bg_3.png'),
  poster_bg_4: require('@/assets/images/receiptManager/poster/poster_bg_4.png'),
  poster_tem_1: require('@/assets/images/receiptManager/poster/poster_tem_1.png'),
  poster_tem_2: require('@/assets/images/receiptManager/poster/poster_tem_2.png'),
  poster_tem_3: require('@/assets/images/receiptManager/poster/poster_tem_3.png'),
  poster_tem_4: require('@/assets/images/receiptManager/poster/poster_tem_4.png'),
  poster_white_text: require('@/assets/images/receiptManager/poster/poster_white_text.png'),
  poster_black_text: require('@/assets/images/receiptManager/poster/poster_black_text.png'),
  moneyEmptyIcon: require('@/assets/images/receiptManager/money_empty_icon.png'),
  birthdayIcon: require('@/assets/images/aiManager/birthday-icon.png'),
  festivalIcon: require('@/assets/images/aiManager/festival-icon.png'),
  aiRoundLogo: require('@/assets/images/aiManager/ai_round_logo.png'),
  aiReportBg: require('@/assets/images/aiManager/ai_report_bg.png'),
  aiVipBg: require('@/assets/images/aiManager/ai_vip_bg.png'),
  aiMoenyIcon: require('@/assets/images/aiManager/ai_moeny_icon.png'),
  aiVipIcon: require('@/assets/images/aiManager/ai_vip_icon.png'),
  aiServiceIcon: require('@/assets/images/aiManager/ai_service_icon.png'),
  likeIcon: require('@/assets/images/aiManager/is_like_icon.png'),
  acLikeIcon: require('@/assets/images/aiManager/active_like_icon.png'),
  noLikeIcon: require('@/assets/images/aiManager/no_like_icon.png'),
  acNoLikeIcon: require('@/assets/images/aiManager/active_dislike_icon.png'),
  redDownIcon: require('@/assets/images/aiManager/red_up_icon.png'),
  greenDownIcon: require('@/assets/images/aiManager/green_down_icon.png'),
  vipRechargeIcon: require('@/assets/images/aiManager/recharge_icon.png'),
  keyboardSaveIcon: require('@/assets/images/common/icon_keyboard_save.png'), // 键盘安全图标
  keyboardCloseIcon: require('@/assets/images/common/icon_keyboard_close.png'), // 键盘安全
  keyboardDelIcon: require('@/assets/images/common/icon_keyboard_del.png'), // 键盘删除
  wainIcon: require('@/assets/images/common/wain_icon.png')
}

/**
 * @constant 本地存储信息
 */
export const LOCAL_CACHE_KEYS = {
  rechargeMermber: 'RECHARGE_MEMBER_INFO',
  aiBusinessHelperFrom: 'AI_BUSINESS_HELPER_FROM_PAGE'
}

/**
 * @constant 验证码弹窗类型
 */
export const CAPTCHA_CODE_TYPE = {
  password: 'password',
  code: 'code'
}
